module.exports = __webpack_public_path__ + "img/5.430f7ac3.png";